
import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link, useNavigate } from "react-router-dom";
import storage from "../../Services/Storage";
import { createAPIEndpointCollateralDestroy, EndpointCollateralDestroy } from "../../Services/CollateralDestroy/CollateralDestroyService";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";


const CollateralDestroyAllRecords = () => {
    const auth = storage.getLocal("user");
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [allRecordData, setAllRecordData] = useState();
    const [loader, setLoader] = useState(false);

    const getCollateralDestroyAllData = async () => {
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startDate);
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {
            setLoader(true);
            const res = await createAPIEndpointCollateralDestroy().get(`${EndpointCollateralDestroy.PopulateSTKAdjstData}?strStartDate=${formattedStartDate}&strEndDate=${formattedEndDate}&strUserId=${auth.UserId}`);
            setAllRecordData(res.data.Data);
            if(res.data.Data.length == 0) {
                toast.warning(
                    "No data found between these dates",
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
            }

        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoader(false);
        }
    };

    useEffect(()=>{
        getCollateralDestroyAllData();
    },[]);

    let nav = useNavigate();

    const toViewPage = (rowdata) => {
        return (
            <div className="action-icon">
                <button
                    className="grid-icon-img"
                    title="View Details"
                    onClick={() => {
                        nav(`/inventorymanagement/CollateralDestroy?stkAdjId=${encodeURIComponent(rowdata.MASK_STK_ADJ_HDR_ID)}`);
                    }}
                >
                    <img
                        alt="InnoRise"
                        src={require("../../Assets/Images/ViewEdit.png")}
                    />
                </button>
            </div>
        );
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Collateral Destroy</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <Link to="/inventorymanagement/CollateralDestroy">
                                <button type="submit" title='Add New' className="btn btn-primary" >
                                    Add New
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-5 col-md-5 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">From Date </label>
                                <Calendar value={startDate}
                                    onChange={(e) => setStartDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">To Date</label>
                                <Calendar value={endDate}
                                    onChange={(e) => setEndDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12">
                            <div className="float-end mb-2">
                                <button type="submit" title='Download' className="btn btn-primary" onClick={getCollateralDestroyAllData}>
                                    Get Data
                                </button>
                            </div>
                        </div>

                    </div>
                </section>
                {loader?<><Loader/></>:<section className="">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">Records</h3>
                        <div className="DataTable">
                            <DataTable
                                paginator
                                rows={10}
                                value={allRecordData}
                                filterDisplay="row"
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column field="WAREHOUSE_DESCRIPTION" header="Warehouse"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."></Column>
                                <Column field="STK_ADJ_NO" header="Stock Adjustment No"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..." />
                                <Column field="STOCK_ADJUSTMENT_DATE" header="Date "
                                    filter
                                    filterPlaceholder="Search Here..."></Column>
                                <Column field="MASK_STATUS" header="Status"
                                    filter
                                    filterPlaceholder="Search Here..."></Column>
                                <Column body={toViewPage} header="Action"></Column>
                            </DataTable>
                        </div>
                    </div>
                </section>}
            </div>
        </>
    );
};

export default CollateralDestroyAllRecords;